module.exports = __webpack_public_path__ + "static/media/eina04-regular.be30c540.woff";